module.exports = __webpack_public_path__ + "67eed7dbbb78253f331c88fcf8e3e921.pdf";